/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @material-ui core components
import { useContext } from 'react'

import { Autocomplete, Grid } from '@mui/material'

// Material Dashboard 2 PRO React TS components
import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import {
	ALL_CARD_FEEDBACK_TYPE_OPTIONS,
	ALL_TIMEFRAME_OPTIONS,
} from 'layouts/dashboards/analytics/constants'
import { FormContext } from 'layouts/organisation-member/constants'
import { OrganisationMember } from 'layouts/organisation-member/types'
import ComplexStatisticsCard from 'modules/Cards/StatisticsCards/ComplexStatisticsCard'

function Analytics() {
	const formContext = useContext(FormContext)
	const { localForm, setLocalForm } = formContext

	const handleFormUpdate = (value: string, field: keyof OrganisationMember['analytics']) => {
		setLocalForm(prev => ({
			...prev,
			analytics: {
				...prev.analytics,
				[field]: value,
			},
		}))
	}

	if (localForm.analytics) {
		return (
			<MDBox>
				<MDBox display={'flex'} flexDirection={'row'} gap={2} p={3}>
					<MDAvatar bgColor="primary" size="xs">
						4
					</MDAvatar>
					<MDTypography variant="h5" fontWeight="medium">
						Analytics
					</MDTypography>
				</MDBox>
				<MDBox display={'flex'} flexDirection={'row'} gap={3} alignItems="center" ml={4}>
					<MDBox display="flex" alignItems="center" mb={4}>
						<MDTypography variant="h6" color="secondary">
							Cards Feedback Type:&nbsp;&nbsp;&nbsp;
						</MDTypography>
						<Autocomplete
							disableClearable
							value={localForm.analytics?.feedbackType}
							options={ALL_CARD_FEEDBACK_TYPE_OPTIONS}
							onChange={(_, newValue) => {
								handleFormUpdate(newValue, 'feedbackType')
							}}
							size="medium"
							sx={{ width: '12rem' }}
							renderInput={params => <MDInput {...params} />}
						/>
					</MDBox>
					<MDBox display="flex" alignItems="center" mb={4} mr={4}>
						<MDTypography variant="h6" color="secondary">
							Timeframe:&nbsp;&nbsp;&nbsp;
						</MDTypography>
						<Autocomplete
							disableClearable
							value={localForm.analytics?.timeframe}
							options={ALL_TIMEFRAME_OPTIONS}
							onChange={(_, newValue) => {
								handleFormUpdate(newValue, 'timeframe')
							}}
							size="medium"
							sx={{ width: '10rem' }}
							renderInput={params => <MDInput {...params} />}
						/>
					</MDBox>
				</MDBox>
				<Grid container spacing={3} pt={1}>
					<Grid item xs={12} sm={6} lg={4}>
						<ComplexStatisticsCard
							color="info"
							icon="hourglass_bottom"
							title="Pending"
							count={localForm.analytics.statistics.pending.value}
							data={localForm.analytics.statistics.pending.data}
						/>
					</Grid>
					<Grid item xs={12} sm={6} lg={4}>
						<ComplexStatisticsCard
							color="success"
							icon="inbox"
							title="Completed"
							count={localForm.analytics.statistics.complete.value}
							data={localForm.analytics.statistics.complete.data}
						/>
					</Grid>
					<Grid item xs={12} sm={6} lg={4}>
						<ComplexStatisticsCard
							icon="timer"
							title="Overdue"
							color="error"
							count={localForm.analytics.statistics.overdue.value}
							data={localForm.analytics.statistics.overdue.data}
						/>
					</Grid>
				</Grid>
			</MDBox>
		)
	} else {
		return <></>
	}
}

export default Analytics
